import Modal from '../Utils/Modal';
import { FormattedMessage } from 'react-intl';
import '../../styles/salesmanModal.scss';
import { connect } from 'react-redux';
import { COMPLETED } from '../../reducers/dataLoadedReducerCreator';
import SalesmanModalLoader from '../Loader/SalesmanModalLoader';

const SalesmanModal = (props) => (
  <Modal {...props}>
    <div className='modal-container' style={{ minWidth: '450px' }}>
      {props.status === COMPLETED && (
        <>
          <span className='modal-heading'>
            <FormattedMessage id='Your salesman heading' />
            <br />
            <br />
            <div style={{ fontWeight: 500, textAlign: 'center' }}>
              {props.data?.firstName} <span className='salesman-last-name'>{props.data?.lastName}</span>
            </div>
          </span>
          <a href={`tel:${props.data?.phoneNumber}`} className='salesman-phone'>
            {props.data?.phoneNumber}
          </a>
          <a href={`mailto:${props.data?.email}`} className='salesman-email' target='_blank' rel='noopener noreferrer'>
            {props.data?.email}
          </a>
          <a href={`mailto:${props.data?.email}`} className='button button-red' target='_blank' rel='noopener noreferrer'>
            <FormattedMessage id='Write to me' />
          </a>
        </>
      )}
      {props.status !== COMPLETED && <SalesmanModalLoader />}
    </div>
  </Modal>
);

export default connect((state) => state.salesman)(SalesmanModal);
